import DeliveryProviders from './DeliveryProviders';
import OrderMethods from './OrderMethods';

export default {
  DeliveryProviders,
  OrderMethods,
};
